<mat-card *ngIf="!preFilterDataLoaded">
  <mat-card-header>
    <mat-card-title>
      <b>Pre-Filter Data Cache Still Loading</b>
     </mat-card-title>
     <mat-card-subtitle>
       It will be cached locally and held for a week before a refresh is required.  This message will disappear once the data is available.
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-md-2"><b>Regions</b></div>
      <div class="col-md-2"><b>Industries</b></div>
      <div class="col-md-2"><b>Occupations</b></div>
      <div class="col-md-2"><b>Titles</b></div>
      <div class="col-md-2"><b>Organizations</b></div>
    </div>
    <div class="row">
      <div class="col-md-2" *ngIf="cacheLoadState?.regionsLoaded">Cache Availble!</div>
      <div class="col-md-2" *ngIf="!cacheLoadState?.regionsLoaded">Loading Cache...</div>

      <div class="col-md-2" *ngIf="cacheLoadState?.industriesLoaded">Cache Availble!</div>
      <div class="col-md-2" *ngIf="!cacheLoadState?.industriesLoaded">Loading Cache...</div>

      <div class="col-md-2" *ngIf="cacheLoadState?.occupationsLoaded">Cache Availble!</div>
      <div class="col-md-2" *ngIf="!cacheLoadState?.occupationsLoaded">Loading Cache...</div>

      <div class="col-md-2" *ngIf="cacheLoadState?.titlesLoaded">Cache Availble!</div>
      <div class="col-md-2" *ngIf="!cacheLoadState?.titlesLoaded">
        Loading... ({{cacheLoadState?.titlesLoadedCount / cacheLoadState?.titlesTotal | percent:'2.2-2'}})
      </div>

      <div class="col-md-2" *ngIf="cacheLoadState?.organizationsLoaded">Cache Availble!</div>
      <div class="col-md-2" *ngIf="!cacheLoadState?.organizationsLoaded">
        Loading... ({{cacheLoadState?.organizationsLoadedCount / cacheLoadState?.organizationsTotal | percent:'2.2-2'}})
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <div class="row">
      <div class="col-md-6">
        <mat-select [(value)]="selectedPreFilterId" (selectionChange)="loadPreFilterData()">
          <mat-option [value]="0">Select Existing Pre Filter...</mat-option>
          <mat-option *ngFor="let preFilter of userState.preFilters" [value]="preFilter.preFilterId">{{preFilter.name}}</mat-option>
        </mat-select>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <a href="#" (click)="createNewPreFilter()">Create New</a>
          </div>
          <div class="col-md-4">
            <a href="#" *ngIf="selectedPreFilterId !== 0" (click)="deletePreFilter()">Delete</a>
          </div>
          <div class="col-md-4">
            <a href="#" *ngIf="selectedPreFilterId !== 0 && !selectedPreFilter.isDefault" (click)="makePreFilterDefault()">Make Default</a>
            <ng-container *ngIf="selectedPreFilterId !== 0 && selectedPreFilter.isDefault">
              <b>* Current Default *</b>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="selectedPreFilterId !== 0">
  <mat-card-content>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <h5>Pre Filter Values</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5"><a href="#" (click)="editValues()">Edit Values</a></div>
          <div class="col-md-5"></div>
        </div>
        <!--<div class="row">
          <div class="col-md-5"><button mat-button class="piButton" (click)="editTitleValues()">Edit Title Values</button></div>
          <div class="col-md-5"><button mat-button class="piButton" (click)="editCompanyValues()">Edit Company Values</button></div>
        </div>
        <div class="row"><br /></div>
        <div class="row">
          <div class="col-md-5"><button mat-button class="piButton" (click)="editRegionValues()">Edit Region Values</button></div>
          <div class="col-md-5"><button mat-button class="piButton" (click)="editIndustryValues()">Edit Industry Values</button></div>
        </div>
        <div class="row"><br /></div>
        <div class="row">
          <div class="col-md-5"><button mat-button class="piButton" (click)="editOccupationValues()">Edit Occupation Values</button></div>
          <div class="col-md-5"></div>
        </div>-->
      </div>
      <div class="col-md-6">
        <ng-container *ngIf="!isReportSubscription">
          <div class="row">
            <div class="col-md-6">
              <h5>Applied Interactives</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-select [(ngModel)]="selectedInteractiveId">
                <mat-option *ngFor="let interactive of availableInteractives" [value]="interactive.interactId">{{interactive.interactName}}</mat-option>
              </mat-select>
            </div>
            <div class="col-md-6">
              <a href="#" (click)="addAppliedInteractive()">Add Interactive</a>
            </div>
          </div>
          <br />
          <div class="row" style="padding-top: 15px">
            <div class="col-md-8 mainLabel">Interactive</div>
            <div class="col-md-4 mainLabel"></div>
          </div>
          <div *ngFor="let interactive of appliedInteractives" class="row table-row" style="padding-top: 5px">
            <div class="col-md-8">{{interactive.interactName}}</div>
            <div class="col-md-4">
              <a href="#" (click)="removeAppliedInteractive(interactive.interactId)">Remove</a>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-card-content>
</mat-card>
